import Blue from "../core";

new Blue({
	name: 'Side Nav Scroll Height',
	selector: ".conference-nav, .header-side, .profile-nav, .search-filters",
	setup(nav) {
		const container = nav.closest(".page-sidebar");
		// select inner content of nav that determines scroll height
		const navContentsHeight = [...container.querySelectorAll(".conference-nav__header, nav.conference-nav__nav, .header-side__inner")]
			.reduce((prev, current) => prev + current.scrollHeight, 0);
		// Only init below code to reset height if the content of the nav is tall enough to necessitate scrolling inside nav
		if (!!container && navContentsHeight > (window.innerHeight - (window.pageYOffset + container.getBoundingClientRect().top))) {
			let containerTop;
			const setHeight = () => {
				if (window.innerWidth < 768) {
					nav.style.maxHeight = "";
					nav.style.height = "";
					nav.style.overflowY = "";
					return;
				}
				let fullVH = window.innerHeight;		// More consistent on iOS than using 'vh' CSS units
				containerTop = container.getBoundingClientRect().top;
				let newHeight;
				if (containerTop > 0) {
					newHeight = fullVH - containerTop + "px";		// extra 16px gives us some padding so we don't see too much of a gap during scroll
				} else {
					newHeight = fullVH + "px";
				}
				nav.style.maxHeight = newHeight;
				nav.style.height = newHeight;
				nav.style.overflowY = "auto";
			}
			setHeight();

			// Adjust height of nav if available area changes due to scroll
			let scrolling = false;
			let scrollInterval = setInterval(() => {		// Set as variable in case we want to clearInterval() at some point in future update
				if (scrolling) {		// Allows us to throttle scroll event so it doesn't fire the setHeight function at every single scroll point
					scrolling = false;
					setHeight();
				}
			}, 25);

			this.$addEvents(window, "scroll", () => {
				scrolling = true;
				if (window.innerWidth >= 768) {
					nav.style.overflowY = "hidden";
					let fullVH = window.innerHeight;
					nav.style.maxHeight = fullVH + "px";
					nav.style.height = fullVH + "px";
				}
			});

			let windowWidth = window.innerWidth;
			this.$addEvents(window, "resize", () => {
				let newWindowWidth = window.innerWidth;
				console.log("newWindowWidth " + newWindowWidth);
				if (windowWidth !== newWindowWidth && newWindowWidth < 769) {
					console.log("resize");
					nav.style.maxHeight = "";
					nav.style.height = "";
					nav.style.overflowY = "";
				}
				else {
					setHeight();
				}
				windowWidth = newWindowWidth;
			});

		}
		
	}
});
